import { Dialog } from "./dialog";
import {
  Container,
  Footer,
  Header,
  ToggleExpandButton,
} from "./expandable-area";
import { HistoryItem } from "./history";
import { Loader } from "./loader";
import { Message, QuickAnswers, TypingDots } from "./message";
import {
  SidebarContainer,
  SidebarContent,
  SidebarProvider,
  ToggleExpandButton as SidebarToggle,
} from "./side-bar";

export const ChatUi = {
  Container,
  Toggle: ToggleExpandButton,
  Header,
  Footer,
  SidebarContainer,
  SidebarContent,
  SidebarProvider,
  SidebarToggle,
  HistoryItem,
  Message,
  QuickAnswers,
  TypingDots,
  Loader,
};

export const ChatDialog = Dialog;
